import { render, staticRenderFns } from "./dish-item-input.vue?vue&type=template&id=95a808e8&"
import script from "./dish-item-input.vue?vue&type=script&lang=js&"
export * from "./dish-item-input.vue?vue&type=script&lang=js&"
import style0 from "./dish-item-input.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports